import { Component, OnInit, ViewChild, OnDestroy, ViewEncapsulation } from '@angular/core';
import { User } from 'app/models/user';
import { UserService } from 'app/services/user.service';
import { Storage } from 'app/models/storage';
import { StorageService } from 'app/services/storage.service';
import { Router } from '@angular/router';
import { EcoDocsTitleService } from 'app/services/ecodocs-title.service';
import { DashboardService } from 'app/services/dashboard.service';
import { Dashboard } from 'app/models/dashboard';
import { WorkflowExec, WorkflowStatus } from 'app/models/workflow-exec';
import { WorkflowExecutionService } from 'app/services/workflow-execution.service';
import { finalize } from 'rxjs/operators';
import { WorkflowTemplateService } from 'app/services/workflow-template.service';
import { FormTemplateService } from 'app/services/form-template.service';
import { FormTemplate } from 'app/models/template';
import { WorkflowTemplate } from 'app/models/workflow-template';
import { ToastService } from 'ng-uikit-pro-standard';
import { FormFillerComponent } from '../form-filler/form-filler.component';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class HomeComponent implements OnInit, OnDestroy {
  tasks: WorkflowExec[] = [];
  tasksTableLoadingIndicator: boolean = true;
  selectedTasksTableLimit: number = 5;
  
  recentForms: FormTemplate[] = [];
  formsTableLoadingIndicator: boolean = true;
  selectedFormsTableLimit: number = 5;
  
  recentWorkflowTemplates: WorkflowTemplate[] = [];
  workflowsTableLoadingIndicator: boolean = true;
  selectedWorkflowsTableLimit: number = 5;
  
  currentGreeting: string = "";
  currentUser: User;
  
  searchText: string = '';
  storageList: Storage[] = [];

  dashboards: Dashboard[] = [];

  @ViewChild('formFiller') formFiller: FormFillerComponent;
  
  constructor(public userService: UserService, private storageService: StorageService,
              private router: Router, private ecoDocsTitleService: EcoDocsTitleService,
              private dashboardService: DashboardService, private workflowExecutionService: WorkflowExecutionService,
              private workflowTemplateService: WorkflowTemplateService, private formTemplateService: FormTemplateService,
              private toastService: ToastService) { }

  ngOnInit(): void {
    this.ecoDocsTitleService.setTitle('Home', false);

    this.userService.currentUser.subscribe(user => {
      this.currentUser = user;
    });

    this.tasksTableLoadingIndicator = true;
    this.workflowExecutionService.getMyTasks().pipe(finalize(()=> {
      this.tasksTableLoadingIndicator = false;
    })).subscribe((w) => {
      this.tasks = w;
    });

    this.workflowsTableLoadingIndicator = true;
    this.workflowTemplateService.getRecents().pipe(finalize(()=> {
      this.workflowsTableLoadingIndicator = false;
    })).subscribe((w) => {
      this.recentWorkflowTemplates = w;
    });

    this.formsTableLoadingIndicator = true;
    this.formTemplateService.getRecents().pipe(finalize(()=> {
      this.formsTableLoadingIndicator = false;
    })).subscribe((f) => {
      this.recentForms = f;
    });

    this.storageService.allStoragesSubject.subscribe((list)=>this.storageList=list);

    this.dashboardService.currentDashboardsSubject.subscribe((d) => this.dashboards = d);
    this.updateCurrentGreeting();

   
  }

  ngOnDestroy(): void {
    
  }

  public get workflowStatus() : typeof WorkflowStatus {
    return WorkflowStatus;
  }
  
  innerWidth() {
    return window.innerWidth;
  }

  onDashboardClick(d: Dashboard) {
    window.open(d.url);
  }
  
  updateCurrentGreeting() {
    let currentHour: number = new Date().getHours();

    if (currentHour < 12)
        this.currentGreeting = 'Good Morning';
    else if (currentHour >= 12 && currentHour <= 17)
        this.currentGreeting = 'Good Afternoon';
    else if (currentHour >= 17 && currentHour <= 24)
        this.currentGreeting = 'Good Evening';
  }

  beginSearch() {
    this.router.navigate(['/search'], {queryParams: {
      options: JSON.stringify({
          query: this.searchText,
          is_files: true,
          is_user_storage: true,
          is_global_storage: true,
          in_file_contents: true,
          is_forms: true,
          in_form_contents: true,
          forms_folders: [],
          is_data: true
      })
    }});    
  }

  openForm(f: FormTemplate) {
    this.formsTableLoadingIndicator = true;
    this.formTemplateService.getById(f.id).pipe(finalize(() => {
      this.formsTableLoadingIndicator = false;
    })).subscribe((f) => {
      this.formFiller.show(f);
    });
  }

  onFormFilled(event: any) {
    this.formsTableLoadingIndicator = true;
    this.formTemplateService.putSubmission(event.submission).pipe(finalize(() => {
      this.formsTableLoadingIndicator = false;
    })).subscribe((f) => {
      this.toastService.success('Saved!');
    }, error => {
      this.toastService.error('Error saving data!');
    });
  }

  openContainingFolder(f: FormTemplate) {
     this.router.navigateByUrl(this.router.createUrlTree(['forms-explorer', f.path.substr(0, f.path.lastIndexOf('/'))], {}));
  }
}
